import { CSSProperties } from 'react';
import { camelToKebab } from '../components/ThemeInjector/utils';

type ValidCssVariableType = string | number | undefined;

/**
 * Utility function which converts an object of properties into a style object with CSS variables, for use when
 * working with CSS modules.
 *
 * Property names are converted from camelCase to kebab-case.
 *
 * @param props An object containing props to pass though as CSS variables.
 * @returns A style object containing the CSS variables.
 */
export const assignCssVars = (props: Record<string, ValidCssVariableType>) => {
  const styleObject: Record<string, string> = {};

  Object.entries(props).forEach(([propName, value]) => {
    if (value === undefined) {
      return;
    }

    styleObject[`--${camelToKebab(propName)}`] = value.toString();
  });

  return styleObject as CSSProperties;
};
